import React, { useEffect, useState } from "react";
import "./Admin Functions.css";
import { Col } from "react-bootstrap";
import {
  changeGoogleReviewStatusAPI,
  downloadExcelGoogleReviewAPI,
  downloadPDFGoogleReviewAPI,
  getGoogleReviewDataAPI,
} from "../../api";

import { FaCaretDown } from "react-icons/fa";
import Loader from "../Widgets/Loader/Loader";
import VerificationModal from "./VerificationModal/VerificationModal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const GoogleReview = () => {
  const [loading, setLoading] = useState(false);
  const [ExtraData, setExtraData] = useState();

  const [dataPerPageButton, setDataPerPageButton] = useState("10");
  const [currentPage, setCurrentPage] = useState(1);

  const today = new Date().toLocaleDateString("en-CA", {
    timeZone: "Australia/Brisbane",
  });

  const [from_date, setFrom_date] = useState("");
  const [to_date, setTo_date] = useState("");
  const [reviewStatusFilter, setReviewStatusFilter] = useState("");
  const [searchInput, setSearchInput] = useState("");

  const [showReviewStatusModal, setShowReviewStatusModal] = useState(false);
  const [pendingReviewChange, setPendingReviewChange] = useState(null);

  const [originalData, setOriginalData] = useState([]);

  // Single source of truth for the payload so the listing, PDF and Excel
  // calls always send exactly the same filters.
  const buildFormData = ({
    page = currentPage,
    itemsPerPage = dataPerPageButton,
    fromDate = from_date,
    toDate = to_date,
    reviewStatus = reviewStatusFilter,
    searchText = searchInput,
  } = {}) => {
    const formdata = new FormData();
    formdata.append("page", page);
    formdata.append("itemsPerPage", itemsPerPage);
    formdata.append("stage", "");
    formdata.append("status", "");
    formdata.append("current_status", "");
    formdata.append("from_date", fromDate);
    formdata.append("to_date", toDate);
    formdata.append("agent_id", null);
    formdata.append("prn", "");
    formdata.append("applicant_no", "");
    formdata.append("pathway", "");
    formdata.append("d_o_b", "");
    formdata.append("occupation", "");
    formdata.append("tm_filter", "");
    formdata.append("review_status", reviewStatus);
    formdata.append("search_input", searchText);
    return formdata;
  };

  const getGoogleReviewDataFunction = async (data) => {
    try {
      setLoading(true);
      const response = await getGoogleReviewDataAPI(data);
      setLoading(false);
      if (
        response &&
        response?.data &&
        response?.data?.response &&
        response?.data?.response?.response === true &&
        response?.data?.response?.data
      ) {
        setOriginalData(response?.data?.response?.data?.page_data || []);
        setExtraData(response?.data?.response?.data);
      } else {
        setLoading(false);
        console.error(
          "Error fetching google review data:",
          response?.data?.error_msg || "Unknown error"
        );
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching google review data:", error);
    }
  };

  useEffect(() => {
    getGoogleReviewDataFunction(
      buildFormData({
        page: 1,
        itemsPerPage: 10,
        fromDate: "",
        toDate: "",
        reviewStatus: "",
        searchText: "",
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const downloadPDFGoogleReviewFunction = async (data) => {
    try {
      setLoading(true);
      const response = await downloadPDFGoogleReviewAPI(data);
      setLoading(false);
      if (
        response &&
        response?.data &&
        response?.data?.response &&
        response?.data?.response?.response === true &&
        response?.data?.response?.data
      ) {
        if (response?.data?.response?.data?.url) {
          window.open(response?.data?.response?.data?.url, "_blank");
          toast.success(
            response?.data?.response?.success_msg || "Download Opened File."
          );
        }
      } else {
        setLoading(false);
        console.error(
          "Error while downloading PDF",
          response?.data?.error_msg || "Unknown error"
        );
        toast.error(
          response?.data?.response?.error_msg || "Error in downloading."
        );
      }
    } catch (error) {
      setLoading(false);
      console.error("Error while downloading PDF:", error);
    }
  };

  const downloadExcelGoogleReviewFunction = async (data) => {
    try {
      setLoading(true);
      const response = await downloadExcelGoogleReviewAPI(data);
      setLoading(false);
      if (
        response &&
        response?.data &&
        response?.data?.response &&
        response?.data?.response?.response === true &&
        response?.data?.response?.data
      ) {
        if (response?.data?.response?.data?.url) {
          window.open(response?.data?.response?.data?.url, "_blank");
          toast.success(
            response?.data?.response?.success_msg || "Download Opened File."
          );
        }
      } else {
        setLoading(false);
        console.error(
          "Error while downloading Excel",
          response?.data?.error_msg || "Unknown error"
        );
        toast.error(
          response?.data?.response?.error_msg || "Error in downloading."
        );
      }
    } catch (error) {
      setLoading(false);
      console.error("Error while downloading Excel:", error);
    }
  };

  const totalPages = Math.ceil(ExtraData?.totalRows / dataPerPageButton);
  const visiblePages = 4;

  const [startPage, setStartPage] = useState(1);

  useEffect(() => {
    getGoogleReviewDataFunction(buildFormData({ page: currentPage }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, startPage]);

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFirst = () => {
    setCurrentPage(1);
    setStartPage(1);
  };

  const handleLast = () => {
    const lastPage = totalPages;
    setCurrentPage(lastPage);
    const newStartPage = Math.max(1, lastPage - visiblePages + 1);
    setStartPage(newStartPage);
  };

  const handlePrev = () => {
    if (startPage > 1) {
      const newStartPage = Math.max(1, startPage - visiblePages);
      setStartPage(newStartPage);
      setCurrentPage(newStartPage);
    }
  };

  const handleNext = () => {
    if (startPage + visiblePages <= totalPages) {
      const newStartPage = startPage + visiblePages;
      setStartPage(newStartPage);
      setCurrentPage(newStartPage);
    }
  };

  const handleDataPerPageChange = (e) => {
    const newDataPerPage = e.target.value;
    setDataPerPageButton(newDataPerPage);
    setCurrentPage(1);
    setStartPage(1);

    getGoogleReviewDataFunction(
      buildFormData({ page: 1, itemsPerPage: newDataPerPage })
    );
  };

  const viewPDF = () => {
    downloadPDFGoogleReviewFunction(buildFormData());
  };

  const viewSpreadSheet = () => {
    downloadExcelGoogleReviewFunction(buildFormData());
  };

  const onSearch = () => {
    handleFirst();
    getGoogleReviewDataFunction(buildFormData({ page: 1 }));
  };

  const onRefresh = () => {
    setDataPerPageButton("10");
    setCurrentPage(1);
    setStartPage(1);
    setFrom_date("");
    setTo_date("");
    setReviewStatusFilter("");
    setSearchInput("");

    getGoogleReviewDataFunction(
      buildFormData({
        page: 1,
        itemsPerPage: 10,
        fromDate: "",
        toDate: "",
        reviewStatus: "",
        searchText: "",
      })
    );
  };

  // Picking a value only stages the change - nothing is sent until the
  // confirmation modal is answered with Yes. The dropdown stays on its old
  // value in the meantime because it is bound to google_review_status.
  const handleReviewStatusChange = (item, newStatus) => {
    setPendingReviewChange({ item, newStatus });
    setShowReviewStatusModal(true);
  };

  const handleCloseReviewStatusModal = () => {
    setShowReviewStatusModal(false);
    setPendingReviewChange(null);
  };

  const handleConfirmReviewStatusChange = async () => {
    if (!pendingReviewChange) return;

    const { item, newStatus } = pendingReviewChange;

    try {
      setLoading(true);

      const formdata = new FormData();
      formdata.append("pointer_id", item?.id);
      formdata.append("review_status", newStatus);

      const response = await changeGoogleReviewStatusAPI(formdata);
      setLoading(false);

      if (
        response &&
        response?.data &&
        response?.data?.response &&
        response?.data?.response?.response === true
      ) {
        setOriginalData((prev) =>
          prev.map((row) =>
            row?.id === item?.id
              ? { ...row, google_review_status: newStatus }
              : row
          )
        );
        toast.success(
          response?.data?.response?.success_msg ||
            "Review Status changed successfully."
        );
      } else {
        toast.error(
          response?.data?.response?.error_msg ||
            "Error in changing Review Status."
        );
      }
    } catch (error) {
      setLoading(false);
      console.error("Error changing Review Status:", error);
      toast.error("Error in changing Review Status.");
    } finally {
      handleCloseReviewStatusModal();
    }
  };

  const onFromDateChange = (e) => {
    setFrom_date(e.target.value);
  };
  const onToDateChange = (e) => {
    setTo_date(e.target.value);
  };
  const onReviewStatusFilterChange = (e) => {
    setReviewStatusFilter(e.target.value);
  };
  const onSearchInputChange = (e) => {
    setSearchInput(e.target.value);
  };

  const handleNavigateToViewApplication = (event, id) => {
    event.preventDefault();

    window.open(
      `/admin/application_manager/view_application?pointerID=${encodeURIComponent(
        id
      )}`,
      "_blank"
    );
  };

  return (
    <>
      {loading && <Loader />}

      <div className="table-responsive">
        <div className="row align-items-end sdrop mx-3 g-1">
          <Col
            lg="1"
            className=""
            style={{
              position: "relative",
              display: "inline-block",
              width: "50px",
            }}
          >
            <div>
              <select
                value={dataPerPageButton}
                onChange={handleDataPerPageChange}
                style={{
                  width: "100%",
                  padding: "6px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                  appearance: "none",
                  WebkitAppearance: "none",
                  MozAppearance: "none",
                  backgroundColor: "white",
                  cursor: "pointer",
                }}
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              <FaCaretDown
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "5px",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  fontSize: "14px",
                  color: "#333",
                }}
              />
            </div>
          </Col>
          <div className="col">
            <label>
              <b>From Date</b>
            </label>
            <input
              type="date"
              name="from_date"
              value={from_date}
              id="from_date"
              onChange={onFromDateChange}
              className="form-control"
              style={{ cursor: "pointer", height: "calc(1.5em + .75rem + 2px)" }}
            />
          </div>
          <div className="col">
            <label>
              <b>To Date</b>
            </label>
            <input
              type="date"
              name="to_date"
              value={to_date}
              id="to_date"
              max={today}
              onChange={onToDateChange}
              className="form-control"
              style={{ cursor: "pointer", height: "calc(1.5em + .75rem + 2px)" }}
            />
          </div>

          <div className="col">
            <label>
              <b>Review Status</b>
            </label>
            <select
              name="reviewStatusFilter"
              id="reviewStatusFilter"
              value={reviewStatusFilter}
              onChange={onReviewStatusFilterChange}
              className="form-select"
              style={{ cursor: "pointer" }}
            >
              <option value="">All</option>
              <option value="Received">Received</option>
              <option value="Pending">Pending</option>
            </select>
          </div>

          <div className="col">
            <label>
              <b>Search</b>
            </label>
            <input
              type="search"
              name="search_input"
              id="search_input"
              value={searchInput}
              placeholder="Search"
              onChange={onSearchInputChange}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onSearch();
                }
              }}
              className="form-control"
              style={{ height: "calc(1.5em + .75rem + 2px)" }}
            />
          </div>

          <div className="col d-flex exports_fun align-items-end">
            <button
              className="btn_green_yellow me-1 btn_report_search"
              onClick={onSearch}
            >
              <i className="bi bi-search"></i>
            </button>
            <button
              className="btn_yellow_green btn_report_search"
              onClick={onRefresh}
              title="Refresh"
            >
              <i className="bi bi-arrow-clockwise"></i>
            </button>
          </div>
          <div className="d-flex exports_fun col filesd">
            <a
              onClick={viewPDF}
              className="btn float-end pdf_design me-1"
              title="Export to PDF"
              style={{
                transition: "transform 0.1s ease-in-out",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = "scale(1.2)")
              }
              onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
              <i
                className="bi bi-file-pdf-fill"
                style={{ transition: "transform 0.1s ease-in-out" }}
              ></i>
            </a>

            <a
              onClick={viewSpreadSheet}
              className="btn float-end excel_design"
              title="Export to Excel"
              style={{
                transition: "transform 0.1s ease-in-out",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = "scale(1.2)")
              }
              onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
              <i
                className="bi bi-file-earmark-spreadsheet"
                style={{ transition: "transform 0.1s ease-in-out" }}
              ></i>
            </a>
          </div>
        </div>
      </div>

      <div id="table_wrapper" className="dataTables_wrapper no-footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <div class="table-responsive table-wrapper">
                <table
                  class="table table-striped table-hover dataTable no-footer"
                  style={{ cursor: "default" }}
                >
                  <thead>
                    <tr>
                      <th scope="col" className="th_font_size">
                        Sr.No.
                      </th>
                      <th scope="col" className="th_font_size">
                        PRN
                      </th>
                      <th scope="col" className="th_font_size">
                        Applicant No.
                      </th>
                      <th scope="col" className="th_font_size">
                        Applicant Name
                      </th>
                      <th scope="col" className="th_font_size">
                        D.O.B.
                      </th>
                      <th scope="col" className="th_font_size">
                        Occupation
                      </th>
                      <th scope="col" className="th_font_size">
                        Pathway
                      </th>
                      <th scope="col" className="th_font_size">
                        Email
                      </th>
                      <th scope="col" className="th_font_size">
                        Mobile No
                      </th>
                      <th scope="col" className="th_font_size">
                        Date Sent
                      </th>
                      <th scope="col" className="th_font_size col-2">
                        Review Status
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {originalData.map((item, index) => (
                      <tr key={index} className={index % 2 === 0 ? "even" : "odd"}>
                        <td className="td_font_size">{index + 1}.</td>
                        <td className="td_font_size">{item?.prn}</td>
                        <td className="td_font_size">{item?.applicant_no}</td>

                        <td
                          onClick={(event) =>
                            handleNavigateToViewApplication(event, item?.id)
                          }
                          style={{ color: "#055837", cursor: "pointer" }}
                          className="hover-underline td_font_size"
                        >
                          {item?.applicant_name}
                        </td>

                        <td className="td_font_size">{item?.dob}</td>
                        <td className="td_font_size">{item?.occupation}</td>
                        <td className="td_font_size">{item?.pathway}</td>
                        <td className="td_font_size">{item?.email}</td>
                        <td className="td_font_size">{item?.mobile_number}</td>
                        <td className="td_font_size">{item?.approved_ads_sent_date}</td>
                        <td className="td_font_size">
                          <select
                            className="form-select"
                            style={{ cursor: "pointer" }}
                            value={item?.google_review_status || ""}
                            onChange={(e) =>
                              handleReviewStatusChange(item, e.target.value)
                            }
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="Received">Received</option>
                            <option value="Pending">Pending</option>
                          </select>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <hr className="thick-hr" />

        <div className="pagination-container p-3">
          <div className="dataTables_info">
            Showing {ExtraData?.totalRows ? ExtraData?.currentPage : 0} to{" "}
            {ExtraData?.totalRows ? ExtraData?.itemsPerPage : 0} of{" "}
            {ExtraData?.totalRows || 0} entries
          </div>

          <div className="pagination-buttons">
            <button
              className={`paginate_button ${currentPage === 1 ? "disabled" : ""}`}
              onClick={handleFirst}
              disabled={currentPage === 1}
            >
              First
            </button>

            <div style={{ display: "flex", alignItems: "center" }}>
              <button
                className={`paginate_button ${startPage === 1 ? "disabled" : ""}`}
                onClick={handlePrev}
                disabled={startPage === 1}
              >
                Previous
              </button>

              <div style={{ overflowX: "auto", whiteSpace: "nowrap", flex: 1 }}>
                {Array.from({ length: visiblePages }, (_, index) => {
                  const pageNumber = startPage + index;
                  if (pageNumber > totalPages) return null;

                  const isActive = currentPage === pageNumber;

                  return (
                    <button
                      key={pageNumber}
                      className={`paginate_button ${isActive ? "active" : ""}`}
                      style={{
                        display: "inline-block",
                        margin: "0 4px",
                        backgroundColor: isActive ? "black" : "transparent",
                        color: isActive ? "white" : "black",
                      }}
                      onClick={() => handlePageClick(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  );
                })}
              </div>

              <button
                className={`paginate_button ${
                  startPage + visiblePages - 1 >= totalPages ? "disabled" : ""
                }`}
                onClick={handleNext}
                disabled={startPage + visiblePages - 1 >= totalPages}
              >
                Next
              </button>
            </div>

            <button
              className={`paginate_button ${
                currentPage === totalPages ? "disabled" : ""
              }`}
              onClick={handleLast}
              disabled={currentPage === totalPages}
            >
              Last
            </button>
          </div>
        </div>
      </div>

      <VerificationModal
        show={showReviewStatusModal}
        onClose={handleCloseReviewStatusModal}
        onYes={handleConfirmReviewStatusChange}
        Title="Confirm !"
        Message={
          <>
            Are you sure you want to change the Review Status for{" "}
            <span style={{ fontWeight: "bold", color: "blue" }}>
              {pendingReviewChange?.item?.applicant_name}
            </span>{" "}
            to{" "}
            <span style={{ fontWeight: "bold", color: "red" }}>
              {pendingReviewChange?.newStatus}
            </span>{" "}
            ?
          </>
        }
      />
    </>
  );
};

export default GoogleReview;
